import type { CacheKey } from "./types";

export function serializeKey(key: CacheKey): string {
  return JSON.stringify(key);
}

/**
 * Returns true if `keySerialized` (a JSON-serialized array key) starts with
 * the same elements as `prefixSerialized` (also a serialized array). Matches
 * either an exact equality or a strict array-prefix relationship.
 */
export function isPrefix(
  prefixSerialized: string,
  keySerialized: string,
): boolean {
  if (keySerialized === prefixSerialized) return true;
  // strip trailing ']' off the prefix and require the key to start with
  // "<prefix-without-bracket>," — i.e. the next array element follows.
  const prefixWithoutBracket = prefixSerialized.slice(0, -1);
  return keySerialized.startsWith(prefixWithoutBracket + ",");
}
